import React, { useState } from "react";
import { handleSubscribe } from "@/utils/subscribeHandler";
import { Input } from "./input";
import { Button } from "./button";
import { ArrowRight } from "lucide-react";
import { useToast } from "../../hooks/use-toast";

const SubscribeNewsletter = () => {
  const [email, setEmail] = useState("");
  const { toast } = useToast();

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubscribe(email, setEmail, toast);
  };

  return (
    <>
      <div className="space-y-4">
        <h3 className="text-sm font-semibold">Stay Updated</h3>
        <p className="text-sm text-muted-foreground">
          Subscribe to get notified about new blog posts and projects.
        </p>
        <form onSubmit={onSubmit} className="space-y-2">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="text-sm"
            required
          />
          <Button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white"
          >
            Subscribe
            <ArrowRight className="ml-2 h-3 w-3" />
          </Button>
        </form>
      </div>
    </>
  );
};

export default SubscribeNewsletter;
